export default {"src":"/_next/static/media/10.35119d13.svg","height":121,"width":173,"blurWidth":0,"blurHeight":0};